










































































import { Component, Vue } from "vue-property-decorator";
import { Action, Mutation, State } from "vuex-class";
import { user, userInfo } from "@/board";

@Component
export default class Settings extends Vue {
  @Action updateUserInfo;
  @State("myUser") storeMyUser: user;
  @State("settingsError") storeSettingsError: string[];
  @Mutation setSettingsError;
  @Mutation clearSettingsError;
  private userInfo: userInfo = {
    email: "",
    name: "",
    password: undefined,
    picture: "",
    oldPassword: undefined,
    newPassword: undefined,
    newNewPassword: undefined,
  };
  private userInfoFieldErrors = {
    email: false,
    name: false,
    password: false,
    picture: false,
    oldPassword: false,
    newPassword: false,
    newNewPassword: false,
  };

  get errors() {
    return this.storeSettingsError;
  }

  clearErrors() {
    this.clearSettingsError();
    this.userInfoFieldErrors = {
      email: false,
      name: false,
      password: false,
      picture: false,
      oldPassword: false,
      newPassword: false,
      newNewPassword: false,
    };
  }

  saveChanges(e) {
    e.preventDefault();
    this.clearSettingsError();
    if (!this.userInfo.email) {
      this.setSettingsError("Email is required");
      this.userInfoFieldErrors.email = true;
    }
    if (!this.userInfo.name) {
      this.setSettingsError("Name is required");
      this.userInfoFieldErrors.name = true;
    }
    if (this.userInfo.newPassword && !this.userInfo.oldPassword) {
      this.setSettingsError("Please input the old password");
      this.userInfoFieldErrors.oldPassword = true;
    }
    if (
      this.userInfo.newPassword &&
      this.userInfo.newPassword !== this.userInfo.newNewPassword
    ) {
      this.setSettingsError("New password and confirmation doesn't match");
      this.userInfoFieldErrors.newPassword = true;
      this.userInfoFieldErrors.newNewPassword = true;
    } else {
      this.userInfo.password = this.userInfo.newPassword;
    }
    if (this.errors.length < 1) {
      const newUser = this.storeMyUser;
      newUser.email = this.userInfo.email;
      newUser.picture = this.userInfo.picture;
      newUser.name = this.userInfo.name;
      this.updateUserInfo(this.userInfo);
    }
  }

  mounted() {
    this.userInfo = {
      email: this.storeMyUser.email,
      name: this.storeMyUser.name,
      password: undefined,
      picture: this.storeMyUser.picture,
      oldPassword: undefined,
      newPassword: undefined,
      newNewPassword: undefined,
    };
  }
}
